<template>
  <div class="w3-col w3-left-align">
    <content-header
      v-bind:title="$t('chooseDesk', { siteName: currentSiteName })"
    ></content-header>
  </div>

  <div class="w3-container w3-margin-bottom zero">
    <loading v-bind:dspin="!contentLoaded"></loading>
  </div>

  <div
    class="flow-card blue-top w3-padding qpp-margin-sides-5pc w-85pc"
    v-show="contentLoaded"
  >
    <table class="w3-table w3-bordered flow-table">
      <thead class="">
        <th>{{ $t("desk") }}</th>
        <th>{{ $t("waitingRoom") }}</th>
        <th>{{ $t("user") }}</th>
        <th class="qpp-text-align-center">
          {{
            currentUserRole !== "ADMIN" || this.$tooManyUsers
              ? $t("linkMe")
              : ""
          }}
        </th>
      </thead>

      <tbody v-show="immutableDeskLinks.length === 0">
        <tr>
          <td class="w3-center flow-main-color">
            <b class="font-size-1pt25em">{{ $t("nodesks") }}</b>
            {{ immutableDeskLinks }}
          </td>
        </tr>
      </tbody>

      <tbody v-show="immutableDeskLinks.length !== 0">
        <tr
          v-for="deskLink in immutableDeskLinks"
          v-bind:id="deskLink.deskId"
          :key="deskLink.deskId"
        >
          <td>
            <router-link
              class="flow-green-active-color font-weight-bold"
              v-if="mutableDeskLinks[deskLink.deskId].userId === currentUserId"
              :to="{
                name: 'visit',
                params: { deskId: deskLink.deskId, userId: currentUserId },
              }"
              >{{ deskLink.deskName }}
            </router-link>
            <span v-else> {{ deskLink.deskName }}</span>
          </td>
          <td class="w-25pc">
            <flow-select
              :callback="
                (wr) => {
                  deskLink.waitingRoomId = wr.id;
                }
              "
              :items="wRooms"
              :preSelectedItem="preSelectedItem(deskLink.waitingRoomId)"
              :valueKey="'name'"
              :valueKeyIndex="'id'"
              class="w3-block w3-border w3-round-medium"
              type="text"
            >
            </flow-select>
          </td>
          <td
            :class="
              currentUserRole === 'ADMIN' && !this.$tooManyUsers
                ? 'w-25pc'
                : 'qpp-text-align-start qpp-align-buttons'
            "
          >
            <flow-select
              :callback="
                (user) => {
                  deskLink.userId = user.id;
                }
              "
              :items="users"
              :preSelectedItem="preSelectedUser(deskLink.userId)"
              :valueKey="'username'"
              :valueKeyIndex="'id'"
              class="w3-block w3-border w3-round-medium"
              type="text"
              v-if="currentUserRole === 'ADMIN' && !this.$tooManyUsers"
            >
            </flow-select>

            <span v-else>
              <span class="w3-tooltip">
                <span> {{ deskLink.firstName }} {{ deskLink.lastName }} </span>
              </span>
            </span>
          </td>

          <td
            class="qpp-text-align-center"
            v-if="currentUserRole !== 'ADMIN' || this.$tooManyUsers"
          >
            <span
              class="btn flow-btn no-break w3-padding-small w3-round-medium flow-green-bg-active-color"
              v-bind:class="
                !isUserLinkedToDesk(deskLink) ? 'cursor-pointer' : 'w3-disabled'
              "
              @click.prevent="linkCurrentUser(deskLink)"
            >
              <i class="far fa-user w3-large imp-white"></i>
            </span>
          </td>

          <td class="qpp-inline-buttons qpp-desks">
            <span
              class="btn flow-btn no-break w3-padding-small w3-round-medium"
              v-bind:class="
                showSaveButton(deskLink) ? 'cursor-pointer' : 'w3-disabled'
              "
              @click.prevent="confirmUpdate(deskLink)"
            >
              <i class="fa fa-link w3-large flow-green-active-color"></i>
              <span
                class="flow-green-active-color flow-margin-left font-weight-bold w3-large"
                >{{ $t("confirm") }}
              </span>
            </span>

            <span
              class="w3-margin-left cursor-pointer btn flow-btn no-break w3-padding-small w3-round-medium"
              v-bind:class="
                mutableDeskLinks[deskLink.deskId].userId === null
                  ? 'w3-disabled'
                  : 'cursor-pointer'
              "
              @click="unlinkDesk(deskLink)"
            >
              <i class="fa fa-unlink w3-text-deep-orange"></i>
              <span
                class="w3-text-deep-orange flow-margin-left font-weight-bold w3-large"
                >{{ $t("unlink") }}</span
              >
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import ContentHeader from "../../common/ContentHeader";
import Loading from "../../common/Loading";
import FlowSelect from "../../common/FlowSelect";
import fetchWaitingRooms from "../../../mixins/fetchWaitingRooms";
import fetchUsers from "../../../mixins/fetchUsers";
import fetchDesks from "../../../mixins/fetchDesks";

export default {
  name: "ConnectDesk",
  components: { ContentHeader, Loading, FlowSelect },
  mixins: [fetchWaitingRooms, fetchUsers, fetchDesks],
  data() {
    return {
      currentUserId: null,
      currentUserFname: null,
      currentUserLname: null,
      currentUserRole: null,
      currentSiteName: null,
      refreshInterval: 30000,
      timeOutId: undefined,
      wRoomsLoaded: false,
      usersLoaded: false,
      wRoomsAndUsersLoaded: false,
    };
  },
  created() {
    this.getWRoomsAndUsers();
    this.currentUserId = this.$store.getters["users/getCurrentUser"].id;
    this.currentSiteName = this.$store.getters["sites/getCurrentSite"].name;
    this.getRefreshInterval();
    this.refresh();
    this.getCurrentUser();
    console.log(this.config);
  },
  methods: {
    refresh() {
      setInterval(() => {
        this.getDeskLinks();
      }, this.refreshInterval);
    },
    getDeskLinks() {
      this.getDesksList();
    },
    getRefreshInterval() {
      this.$restClient.configuration
        .getDeskRefreshProperty()
        .then((response) => {
          let interval = response.data;
          if (!isNaN(interval) && interval >= 10000) {
            this.refreshInterval = interval;
          }
        });
    },
    preSelectedItem(wrId) {
      return this.wRoomsWithKey[wrId];
    },

    preSelectedUser(_userId) {
      let user = null;
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id === _userId) {
          user = this.users[i];
          break;
        }
      }
      return user;
    },

    getCurrentUser() {
      const app = this;
      app.$restClient.qppUsers
        .getUser(app.currentUserId)
        .then((response) => {
          app.currentUserFname = response.data.firstName;
          app.currentUserLname = response.data.lastName;
          app.currentUserRole = response.data.role;
        })
        .catch((err) => {
          console.log(err);
          app.$notify.notifyError({ title: this.$t("failed") });
        });
    },

    getWRoomsAndUsers() {
      this.getWRooms();
      if (!this.$tooManyUsers) {
        this.getUsers();
      }
    },

    isUserLinkedToDesk(deskLink) {
      return deskLink.userId != null && deskLink.userId !== "";
    },

    showSaveButton(deskLink) {
      if (!deskLink) {
        return false;
      }
      let mp = this.mutableDeskLinks[deskLink.deskId];
      if (!mp) {
        return false;
      }

      return (
        mp.waitingRoomId !== deskLink.waitingRoomId ||
        mp.userId !== deskLink.userId
      );
    },

    unlinkDesk(deskLink) {
      if (this.mutableDeskLinks[deskLink.deskId].userId === null) return;
      let app = this;
      app.$restClient.deskDetails
        .unlinkDesk(deskLink.deskId, this.currentUserId)
        .then(() => {
          app.getDeskLinks();
          app.$notify.notifySuccess({
            title: this.$t("success"),
            message: this.$t("modified-success"),
          });
        })
        .catch((err) => {
          console.log(err);
          app.$notify.notifyError({ title: this.$t("failed") });
        });
    },

    linkCurrentUser(deskLink) {
      if (this.isUserLinkedToDesk(deskLink)) return;
      deskLink.userId = this.currentUserId;
      deskLink.firstName = this.currentUserFname;
      deskLink.lastName = this.currentUserLname;
    },

    confirmUpdate(deskLink) {
      if (!this.showSaveButton(deskLink)) return;
      this.updateDesk(deskLink.deskId, deskLink.waitingRoomId, deskLink.userId);
    },

    updateDesk(deskId, waitingRoomId = null, userId = null) {
      let app = this;
      let payload = {
        createdBy: this.currentUserId,
      };

      if (waitingRoomId !== null) {
        payload.waitingRoomId = waitingRoomId;
      }

      if (userId !== null) {
        payload.userId = userId;
      }

      app.$restClient.deskDetails
        .update(deskId, payload)
        .then(() => {
          app.getDeskLinks();
          app.$notify.notifySuccess({
            title: this.$t("success"),
            message: this.$t("modified-success"),
          });
        })
        .catch((err) => {
          if (err.response.status === 400) {
            app.$notify.notifyError({ title: this.$t("deskAlreadyLinked") });
            app.getDeskLinks();
          } else {
            app.$notify.notifyError({ title: this.$t("failed") });
          }
        });
    },
  },
  watch: {
    wRoomsAndUsersLoaded(newValue) {
      if (newValue) {
        console.log("wRoomsAndUsersLoaded");
        this.getDeskLinks();
      }
    },
  },
};
</script>
